import './informativa.scss';

/**
 * version    1.0
 * class      <type> (informativa)
 * classdesc  Component that manage the page two colums
 */
export class Informativa {
  constructor() {
    this.contents = document.querySelectorAll('.informativa__content > div');
    this.buttons = document.querySelectorAll('.informativa__check .btn');

    if (!this.contents.length || !this.buttons.length) return;

    this.init();
  }

  init() {
    this.contents.forEach((content) => {
      content.addEventListener('scroll', () => {
        if (this.isScrolledToBottom(content)) {
          this.enableButtons();
        }
      });
    });
  }

  isScrolledToBottom(el) {
    return el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
  }

  enableButtons() {
    this.buttons.forEach((btn) => {
      btn.classList.remove('disabled');
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
    });
  }
}
